<template>
    <q-table
        :title="title"
        :data="data"
        :columns="columns"
        :pagination="paginationAux"
        :expanded.sync="expanded"
        :rows-per-page-options="[0]"
        :loading="loading"
        row-key="id"
        flat
        card-class="bg-grey-2"
        @request="request"
    >
        <template v-slot:top>
            <slot name="top" />
        </template>
        <template v-slot:header="props">
            <q-tr :props="props">
                <q-th
                    v-for="col in props.cols"
                    :key="col.name"
                    :props="props"
                    :style="{ width: col.name === 'title' ? '20%' : 'auto' }"
                >
                    {{ col.label }}
                </q-th>
            </q-tr>
        </template>
        <template v-slot:body="props">
            <q-tr :props="props">
                <q-td v-for="col in props.cols" :key="col.name" :props="props">
                    <template v-if="col.name === 'expand_btn'">
                        <q-btn
                            v-if="showExpand(props.row)"
                            flat
                            :icon="props.expand ? 'expand_less' : 'expand_more'"
                            @click="expandRow(props)"
                        />
                    </template>
                    <template v-else-if="col.name === 'item_id'">
                        {{ props.rowIndex + 1 }}
                    </template>
                    <template v-else-if="col.name === 'title'">
                        {{
                            props.row.item_type === 'course'
                                ? getTranslationFromJSONString(
                                      props.row.title,
                                      locale.key
                                  )
                                : props.row.title
                        }}
                        <ServicesInCourseBadge
                            v-if="
                                props.row.course_id &&
                                props.row.item_type === 'course'
                            "
                            :course-id="props.row.course_id"
                        >
                        </ServicesInCourseBadge>
                        <template v-if="props.row.description">
                            <q-icon
                                name="info_outlined"
                                size="24px"
                                style="margin-bottom: 5px"
                            >
                            </q-icon>
                            <q-tooltip :offset="[0, -10]">
                                {{ props.row.description }}
                            </q-tooltip>
                            <template v-if="props.row.invalid">
                                <br /><span class="text-secondary">{{
                                    $t('validations.student_already_has_course')
                                }}</span>
                            </template>
                        </template>
                    </template>
                    <template v-else-if="col.name === 'preferred_class_id'">
                        {{
                            props.row.preferred_class_id
                                ? props.row.preferredClass[0].code
                                : '--'
                        }}
                    </template>
                    <template v-else-if="col.name === 'price'">
                        {{
                            new Intl.NumberFormat(
                                JSON.parse(currency.definition)['locale'],
                                {
                                    style: 'currency',
                                    currency: currency.key,
                                }
                            ).format(
                                parseFloat(
                                    JSON.parse(props.row.unit_price)[
                                        currency.key
                                    ]
                                )
                            )
                        }}
                    </template>
                    <template v-else-if="col.name === 'discount'">
                        {{ props.row.discount }}
                    </template>
                    <template v-else-if="col.name === 'quantity'">
                        {{ props.row.quantity }}
                    </template>
                    <template v-else-if="col.name === 'vat'">
                        {{ props.row.tax }}
                    </template>
                    <template v-else-if="col.name === 'total'">
                        {{
                            new Intl.NumberFormat(
                                JSON.parse(currency.definition)['locale'],
                                {
                                    style: 'currency',
                                    currency: currency.key,
                                }
                            ).format(
                                parseFloat(
                                    JSON.parse(props.row.item_total)[
                                        currency.key
                                    ]
                                )
                            )
                        }}
                    </template>
                </q-td>
            </q-tr>
            <!-- expanded order item -->
            <q-tr
                v-show="props.expand"
                :props="props"
                style="background: #f6f6f6"
            >
                <q-td colspan="100%">
                    <q-table
                        :data="props.row.enrollments"
                        :columns="studentColumns"
                        :expanded.sync="expandedStudents"
                        hide-bottom
                        flat
                    >
                        <template v-slot:body="student">
                            <q-tr :props="student">
                                <q-td
                                    v-for="col in student.cols"
                                    :key="col.name"
                                    :props="student"
                                >
                                    <template v-if="col.name === 'expand_btn'">
                                        <q-btn
                                            flat
                                            :icon="
                                                student.row.expand
                                                    ? 'expand_less'
                                                    : 'expand_more'
                                            "
                                            @click="expandStudentRow(student)"
                                        />
                                    </template>
                                    <template v-else-if="col.name === 'name'">
                                        {{ `${student.row.users.first_name}` }}
                                    </template>
                                    <template v-else-if="col.name === 'email'">
                                        {{ student.row.users.email }}
                                    </template>
                                    <template v-else-if="col.name === 'client'">
                                        {{ student.row.client_title }}
                                    </template>
                                    <template v-else-if="col.name === 'class'">
                                        {{ student.row.classes.code }}
                                    </template>
                                    <template v-else-if="col.name === 'active'">
                                        <span
                                            :class="
                                                student.row.active == true
                                                    ? 'text-positive'
                                                    : 'text-grey'
                                            "
                                        >
                                            {{
                                                formatStatus(student.row.active)
                                            }}
                                        </span>
                                    </template>
                                    <template v-else-if="col.name === 'total'">
                                        {{ studentTotal(student.row) }}
                                    </template>
                                </q-td>
                            </q-tr>
                            <!-- expanded student item -->
                            <q-tr
                                v-show="student.expand"
                                :props="student"
                                style="background: #f6f6f6"
                            >
                                <q-td colspan="100%">
                                    <q-table
                                        :data="services"
                                        :columns="serviceColumns"
                                        hide-bottom
                                        flat
                                    >
                                        <template v-slot:body="service">
                                            <q-tr :props="service">
                                                <q-td
                                                    v-for="col in service.cols"
                                                    :key="col.name"
                                                    :props="service"
                                                >
                                                    <template
                                                        v-if="
                                                            col.name === 'name'
                                                        "
                                                    >
                                                        {{ service.row.name }}
                                                    </template>
                                                    <template
                                                        v-else-if="
                                                            col.name ===
                                                            'unit_price'
                                                        "
                                                    >
                                                        {{
                                                            Number(
                                                                service.row
                                                                    .price
                                                            ).toFixed(2)
                                                        }}
                                                    </template>
                                                    <template
                                                        v-else-if="
                                                            col.name ===
                                                            'discount'
                                                        "
                                                    >
                                                        <q-tooltip
                                                            :offset="[0, -10]"
                                                        >
                                                            <span>{{
                                                                $t(
                                                                    'actions.change'
                                                                )
                                                            }}</span>
                                                        </q-tooltip>
                                                        <q-input
                                                            v-model="
                                                                service.row
                                                                    .discount
                                                            "
                                                            style="
                                                                display: inline-block;
                                                                max-width: 120px;
                                                            "
                                                            dense
                                                            outlined
                                                            input-class="text-center"
                                                            :disable="
                                                                !changeItems
                                                            "
                                                        />
                                                        <q-popup-edit
                                                            v-model="
                                                                service.row
                                                                    .discount
                                                            "
                                                            buttons
                                                            self="top middle"
                                                            :title="
                                                                $t(
                                                                    'general.discount'
                                                                )
                                                            "
                                                            :disable="
                                                                !changeItems
                                                            "
                                                        >
                                                            <q-input
                                                                v-model.number="
                                                                    service.row
                                                                        .discount
                                                                "
                                                                dense
                                                                type="number"
                                                                min="0"
                                                                outlined
                                                                input-class="text-center"
                                                                @blur="
                                                                    totalItemsService(
                                                                        service.row
                                                                    )
                                                                "
                                                            />
                                                        </q-popup-edit>
                                                    </template>
                                                    <template
                                                        v-else-if="
                                                            col.name ===
                                                            'quantity'
                                                        "
                                                    >
                                                        <q-tooltip
                                                            :offset="[0, -10]"
                                                        >
                                                            <span>{{
                                                                $t(
                                                                    'actions.change'
                                                                )
                                                            }}</span>
                                                        </q-tooltip>
                                                        <q-input
                                                            v-model="
                                                                service.row
                                                                    .quantity
                                                            "
                                                            style="
                                                                display: inline-block;
                                                                max-width: 120px;
                                                            "
                                                            dense
                                                            outlined
                                                            input-class="text-center"
                                                            :disable="
                                                                !changeItems
                                                            "
                                                        />
                                                        <q-popup-edit
                                                            v-model="
                                                                service.row
                                                                    .quantity
                                                            "
                                                            buttons
                                                            self="top middle"
                                                            :title="
                                                                $t(
                                                                    'general.quantity'
                                                                )
                                                            "
                                                            :disable="
                                                                !changeItems
                                                            "
                                                        >
                                                            <q-input
                                                                v-model.number="
                                                                    service.row
                                                                        .quantity
                                                                "
                                                                dense
                                                                type="number"
                                                                min="0"
                                                                outlined
                                                                input-class="text-center"
                                                                @blur="
                                                                    totalItemsService(
                                                                        service.row
                                                                    )
                                                                "
                                                            />
                                                        </q-popup-edit>
                                                    </template>
                                                    <template
                                                        v-else-if="
                                                            col.name === 'total'
                                                        "
                                                    >
                                                        {{
                                                            updatedTotalService(
                                                                service.row
                                                            )
                                                        }}
                                                    </template>
                                                    <template v-else>
                                                        {{ col.value }}
                                                    </template>
                                                </q-td>
                                            </q-tr>
                                        </template>
                                    </q-table>
                                </q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </q-td>
            </q-tr>
        </template>
    </q-table>
</template>

<script>
import ServicesInCourseBadge from '@/components/orders/ServicesInCourseBadge'
import translate from '@/local-shared/mixins/translate'
import formatDate from '@/helpers/date-time'
import store from '@/store'

export default {
    name: 'OrdersItemsTableComponent',

    components: {
        ServicesInCourseBadge,
    },

    mixins: [translate],

    props: {
        loading: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: null,
        },
        filter: {
            type: Object,
            default: () => {},
        },
        columns: {
            type: Array,
            default: () => [],
        },
        data: {
            type: Array,
            default: () => [],
        },
        pagination: {
            type: Object,
            default: () => {},
        },
        currency: {
            type: Object,
            default: () => {},
        },
        currencyOptions: {
            type: Array,
            default: () => [],
        },
        order: {
            type: Object,
            default: () => ({
                id: null,
            }),
        },
    },

    data() {
        return {
            services: [],
            classes: [],

            expanded: [],
            expandedStudents: [],
            paginationAux: {},
            filterAux: {},
        }
    },

    computed: {
        locale() {
            return store.getters['locale/currentLocale']
        },

        studentColumns() {
            return [
                {
                    name: 'expand_btn',
                    align: 'left',
                },
                {
                    name: 'name',
                    label: this.$t('general.class_enrolled_user'),
                    field: 'users.first_name',
                    align: 'left',
                    sortable: false,
                },
                {
                    name: 'email',
                    label: this.$t('general.email'),
                    field: 'users.email',
                    align: 'left',
                    sortable: false,
                },
                {
                    name: 'class',
                    label: this.$tc('general.class', 1),
                    field: 'classes.code',
                    align: 'left',
                    sortable: false,
                },
                {
                    name: 'active',
                    label: this.$t('general.status'),
                    field: 'active',
                    align: 'left',
                    sortable: false,
                },
                {
                    name: 'total',
                    label: this.$t('general.total'),
                    field: 'total',
                    align: 'right',
                    sortable: false,
                },
            ]
        },

        serviceColumns() {
            return [
                {
                    name: 'name',
                    label: this.$t('general.services'),
                    field: 'name',
                    align: 'left',
                    sortable: false,
                },
                {
                    name: 'unit_price',
                    label: this.$t('general.unit_price'),
                    field: 'unit_price',
                    align: 'center',
                    sortable: false,
                },
                {
                    name: 'quantity',
                    label: this.$t('general.quantity'),
                    field: 'quantity',
                    align: 'center',
                    sortable: false,
                },
                {
                    name: 'vat',
                    label: this.$t('general.vat'),
                    field: 'vat',
                    align: 'center',
                    sortable: false,
                },
                {
                    name: 'total',
                    label: this.$t('general.total'),
                    field: 'total',
                    align: 'right',
                    sortable: false,
                },
            ]
        },
    },

    watch: {
        pagination(value) {
            this.paginationAux = value
        },

        filter(value) {
            this.filterAux = value
        },
    },

    mounted() {
        this.paginationAux = this.pagination
        this.filterAux = this.filter
    },

    methods: {
        totalItems(row) {
            this.updatedTotal(row)
            this.$emit('updateTotal', row.total)
        },

        updatedTotal(row) {
            let servicesTotal = 0
            if (row.enrollments) {
                row.enrollments.forEach((e) => {
                    e.enrolledServices.forEach((s) => {
                        servicesTotal =
                            servicesTotal +
                            parseFloat(
                                JSON.parse(s.item_total)[this.currency.key]
                            )
                    })
                })
            }
            let rowTotal =
                row.price *
                    row.quantity *
                    (1 - row.discount / 100) *
                    (1 + row.tax / 100) +
                servicesTotal
            this.$set(row, 'total', rowTotal.toFixed(2))
            this.$emit('updateTotal', row.total)

            return row.total
        },

        totalItemsService(service) {
            this.updatedTotalService(service)
        },

        updatedTotalService(service) {
            return (service.total = Number(
                service.price *
                    service.quantity *
                    (1 - service.discount / 100) *
                    (1 + service.vat / 100)
            ).toFixed(2))
        },

        studentTotal(student) {
            let total = 0
            if (student.expand === true) {
                this.services.forEach((s) => {
                    total =
                        total +
                        parseFloat(JSON.parse(s.total)[this.currency.key])
                })
            } else {
                student.enrolledServices.forEach((s) => {
                    total =
                        total +
                        parseFloat(JSON.parse(s.item_total)[this.currency.key])
                })
            }
            return total.toFixed(2)
        },

        async expandRow(props) {
            this.expanded = []
            if (!props.expand) {
                await this.mapStudents(props.row)
            }
            return (props.expand = !props.expand)
        },

        async expandStudentRow(student) {
            this.expandedStudents = []
            if (!student.expand) {
                await this.mapServices(student.row)
            }
            return (student.expand = !student.expand)
        },

        removeItem(row) {
            this.$emit('remove', row)
        },

        addEnrollment(row) {
            this.$emit('add-enrollment', row)
        },

        request(props) {
            const { page, rowsPerPage, sortBy, descending } = props.pagination
            const filter = props.filter

            this.paginationAux.page = page
            this.paginationAux.rowsPerPage = rowsPerPage
            this.paginationAux.sortBy = sortBy
            this.paginationAux.descending = descending

            this.filterAux = filter

            this.$emit('request', this.paginationAux, this.filterAux)
        },

        formatDate(value) {
            return value ? formatDate.fromDatePickerToUxDate(value) : null
        },

        mapStudents(orderItem) {
            orderItem.enrollments.forEach((student) => {
                let client_title
                if (student.users.affiliations.length >= 1) {
                    student.users.affiliations.forEach((affiliation) => {
                        client_title = affiliation.active
                            ? affiliation.clients.title
                            : ''
                    })
                }
                student.client_title = client_title
                student.expand = false
                student.total = parseFloat(0).toFixed(2) // Replace when endpoint ready
            })
        },

        mapServices(student) {
            let services = []
            student.enrolledServices.forEach((s) => {
                services.push({
                    id: s.service_id,
                    name: s.service.name,
                    unit_price: s.unit_price,
                    price: parseFloat(
                        JSON.parse(s.unit_price)[this.currency.key]
                    ),
                    discount: 0,
                    vat: s.service.vat.value,
                    quantity: s.quantity,
                    total: parseFloat(
                        JSON.parse(s.item_total)[this.currency.key]
                    ),
                })
            })
            this.services = services
        },

        formatStatus(value) {
            return value == true
                ? this.$t('general.active')
                : this.$t('general.deactivated')
        },

        refresh() {
            this.$emit('refresh')
        },

        showExpand(item) {
            if (item.enrollments) {
                return item.enrollments.length >= 1 ? true : false
            }
            return false
        },
    },
}
</script>
